<template>
	<div>
		<p><a :href="this.link" target="_blank" class="has-text-black">{{ object.title }}</a></p>
		<p class="is-margin-bottom-1-rem has-text-grey">{{ object.type_title }}</p>
		<div v-if="object.type == 'place'" class="buttons has-addons">
			<button type="button" class="button is-small mini-player"
					:data-title="(this.isInRoute ? this.index + '. ' : '') + object.title"
					:data-src="object.audio_preview">
				<span class="icon is-small"><i class="far fa-headphones"></i></span>
			</button>
			<button type="button"
					:class="`button is-small ${this.isInRoute ? 'is-success' : ''}`"
					:title="this.isInRoute ? this.app.Language.get('_.exclude') : this.app.Language.get('_.add')"
					v-on:click="$emit('toggleRouteObject', object.id)">
				<span class="icon is-small">
					<i v-if="this.isInRoute" class="far fa-check"></i>
					<i v-else class="far fa-plus"></i>
				</span>
			</button>
		</div>
	</div>
</template>

<script>
  	import Vue from 'vue';
    import findIndex from 'lodash/findIndex';
    export default Vue.extend({
      props: [
        'app',
        'object',
		'routeObjects'
	  ],
      watch: {
        object: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        },
        routeObjects: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        },
      },
      data () {
        return {

        }
      },
      computed: {
        isInRoute() {
          return this
            .routeObjects
            .filter(routeObject => {
              return routeObject.id === this.object.id
            })
            .length === 1;
        },
        index() {
          if (this.isInRoute) {
            return findIndex(this.routeObjects, {id: this.object.id}) + 1
          }
          return null;
        },
		link() {
          let link = '/content/';

		  if (this.object.type === 'place') {
		    link += 'objects';
		  } else if (this.object.type === 'advice') {
		    link += 'advices';
		  } else if (this.object.type === 'poi') {
		    link += 'poi';
		  }

		  link += '/'+ this.object.id;

		  return link;
		}
	  },
      updated: function () {
        // this.$emit(update:objects, this.items);
      },
	  methods: {

	  }
    })
</script>